import React from 'react';
import './index.css';

const Loader = () => <div className='loadingDot'>.</div>;
export default Loader;
